<template>
  <div>
    <h3 class="page-heading">Assets</h3>
    <div class="flex">
      <nav class="fixed-bar navbar navbar-expand-lg navbar-light bgNav">
        <div class="dropdownItems">
          <div class="btn-group">
            <button
              type="button"
              class="btn btn-info dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Add +
            </button>
            <div class="dropdown-menu">
              <!-- <a
                  class="dropdown-item"
                  @click="$refs.addEnvironment.openDialog()"
                  >3D/2.5D Environment</a
                > -->
              <a class="dropdown-item" @click="$refs.addProp.openDialog()"
                >3D Model</a
              >
              <a class="dropdown-item" @click="$refs.addEffect.openDialog()"
                >Visual Effect</a
              >
              <a class="dropdown-item" @click="$refs.addModel.openDialog()"
                >Character Model</a
              >
              <a
                class="dropdown-item"
                @click="$refs.addCharacterAnimation.openDialog()"
                >Character Animation</a
              >
              <!-- <a class="dropdown-item" @click="$refs.addVoice.openDialog()"
                  >Voice</a
                > -->
              <!-- <a
                  class="dropdown-item"
                  @click="$refs.addAnimation.openDialog()"
                  >Animation</a
                > -->
                <a class="dropdown-item" @click="$refs.addSound.openDialog()"
                  >Sound</a
                >
              <a class="dropdown-item" @click="$refs.addVideo.openDialog()"
                >Video</a
              >
              <a class="dropdown-item" @click="$refs.addOverlay.openDialog()"
                  >Images</a
                >

                <!-- <a class="dropdown-item" @click="$refs.addOverlay.openDialog()"
                  >Lighting</a
                >
                <a class="dropdown-item" @click="$refs.addOverlay.openDialog()"
                  >Movement</a
                >
                <a class="dropdown-item" @click="$refs.addTts.openDialog()"
                  >TTS</a
                >
                <a class="dropdown-item" @click="$refs.addDynamicText.openDialog()"
                  >DS-Dynamic Text</a
                >
                <a class="dropdown-item" @click="$refs.addDsObject2D.openDialog()"
                  >DS-Object 2D</a
                > -->
            </div>
          </div>
        </div>
        <div style="margin: 0px auto" id="tabs">
          <!-- <button
              class="tablink"
              id="threeDEnvironmentId"
              @click="visitDiv('threeDEnvironment')"
            >
              3D/2.5D Environment
            </button> -->
          <button
            class="tablink"
            id="threeDModelId"
            @click="visitDiv('threeDModel')"
          >
            3D Model
          </button>
          <button
            class="tablink"
            id="visualEffectId"
            @click="visitDiv('visualEffect')"
          >
            Visual Effect
          </button>
          <button
            class="tablink"
            id="characterModelId"
            @click="visitDiv('characterModel')"
          >
            Character Model
          </button>
          <button
            class="tablink"
            id="characterAnimationId"
            @click="visitDiv('characterAnimation')"
          >
            Character Animation
          </button>
          <button class="tablink" id="voiceId" @click="visitDiv('voice')">
            Voice
          </button>
          <!-- <button
              class="tablink"
              id="animationId"
              @click="visitDiv('animation')"
            >
              Animation
            </button> -->
          <button class="tablink" id="soundId" @click="visitDiv('sound')">
            Sound
          </button>
          <button class="tablink" id="videoId" @click="visitDiv('video')">
            Video
          </button>
          <button class="tablink" id="imagesId" @click="visitDiv('images')">
            Images
          </button>
          <!-- <button
              class="tablink"
              id="twoDMediaId"
              @click="visitDiv('twoDMedia')"
            >
              2D Media
            </button>
            <button
              class="tablink"
              id="lightingId"
              @click="visitDiv('lighting')"
            >
              Lighting
            </button>
            <button
              class="tablink"
              id="movementId"
              @click="visitDiv('movement')"
            >
              Movement
            </button>
            <button
              class="tablink"
              id="ttsId"
              @click="visitDiv('tts')"
            >
              TTS
            </button>
            <button
              class="tablink"
              id="dynamicTextId"
              @click="visitDiv('dynamicText')"
            >
              DS-Dynamic Text
            </button>
            <button
              class="tablink"
              id="dsObject2DId"
              @click="visitDiv('dsObject2D')"
            >
              DS-Object 2D
            </button> -->
        </div>
      </nav>
      <div class="allDiv">
        <!-- <environment3-d class="my-5" ref="addEnvironment"></environment3-d> -->
        <props class="my-5" ref="addProp"></props>
        <effect class="my-5" ref="addEffect"></effect>
        <character-model class="my-5" ref="addModel"></character-model>
        <character-animation
          class="my-5"
          ref="addCharacterAnimation"
        ></character-animation>
        <voice class="my-5" ref="addVoice"></voice>
        <!-- <prop-animation class="my-5" ref="addAnimation"></prop-animation> -->
        <sound class="my-5" ref="addSound"></sound>

        <Video class="my-5" ref="addVideo" />
        <overlay class="my-5" ref="addOverlay"></overlay>
        <!-- 
          <lighting class="my-5" ref="addLighting"></lighting>
          <movement class="my-5" ref="addMovement"></movement>
          <tts class="my-5" ref="addTts"></tts>
          <dynamic-text class="my-5" ref="addDynamicText"></dynamic-text>
          <ds-object class="my-5" ref="addDsObject2D"></ds-object> -->
      </div>
    </div>
  </div>
</template>

<script>
import Environment3D from "../components/assets/environment3D";
import Props from "../components/assets/props";
import Effect from "../components/assets/effect";
import CharacterModel from "../components/assets/characterModel";
import Voice from "../components/assets/voice";
import CharacterAnimation from "../components/assets/characterAnimation";
import PropAnimation from "../components/assets/propAnimation";
import Sound from "../components/assets/sound";
import Video from "../components/assets/video";
import Overlay from "../components/assets/overlay";
import Lighting from "../components/assets/lighting";
import Movement from "../components/assets/movement";
import Tts from "../components/assets/tts";
import { db } from "../firebaseDB";
import DynamicText from "../components/assets/dynamicText";
import DsObject from "../components/assets/dsObject2D";

export default {
  components: {
    Sound,
    Video,
    Overlay,
    PropAnimation,
    Voice,
    CharacterModel,
    Effect,
    Props,
    Environment3D,
    Lighting,
    Movement,
    Tts,
    DynamicText,
    DsObject,
    CharacterAnimation,
  },
  data: () => ({
    tables: ["set design", "prop", "character action"],
    show: false,
    search: null,
    select: null,
  }),
  methods: {
    visitDiv: function (divId) {
      document.getElementById(divId).scrollIntoView({ behavior: "smooth" });
      var x = document.getElementById("tabs").querySelectorAll(".tablink");
      for (i in x) {
        if (x[i].id === divId + "Id") {
          x[i].classList.add("active");
        } else {
          if (x[i].classList.contains("active") === true) {
            x[i].classList.remove("active");
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 64px;
  z-index: 2;
  margin: 0px auto;
}

.dropdownItems {
  float: left;
  // margin-left: 175px;
  margin-top: -6px;
  font-size: 13px;
}

.tablink {
  border-radius: 10px;
  border: 1px solid #cecece;
  padding: 6px 10px;
  color: #000;
}

.toolBar {
  margin: 0px auto;
}

.tablink:hover {
  background-color: #c4e8d7;
}

.tablink:active {
  background-color: #c4e8d7;
}

/* Style the tab content */
.tabcontent {
  color: white;
  display: none;
  padding: 50px;
  text-align: center;
}

.active,
.btn:hover {
  background-color: #c4e8d7;
}

.bgNav {
  height: 64px;
  background-color: #f5f5f5;
  margin-top: 15px;
  box-shadow: 1px 2px 8px #7777;
}

.card {
  border: 2px solid #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/views/Assets.vue